import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

import type { IndustryTag, PageContent } from '../../pageContents'
const bannerUrl = `${STATIC_OBS_URL}/website/home/solution/banner2.jpg?2`
export interface IndustryListProps {
  tagInfo: IndustryTag
  listData: PageContent[]
  tagList: IndustryTag[]
  routerName: string
}
export const IndustryList = (props: IndustryListProps) => {
  const { tagInfo, listData, tagList } = props
  return (
    <Wrap className='industry-list'>
      <div className='public-banner-box'>
        <div className='mask' style={{ backgroundImage: `url(${bannerUrl})` }} />
        <AnimateBox tagName='h2'>数智赋能工业未来</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          集成数字孪生、控制系统开发、HIL 仿真等全栈解决方案，为工业智能化转型提供强大技术支持
        </AnimateBox>
      </div>

      <div className='public-tab-box white'>
        <div className='inner-wrap'>
          {[...tagList].map((item, i) => {
            const { id, name } = item
            const className = name === tagInfo.name ? 'cur' : ''
            const href = `/industry/${id}`
            return (
              <AnimateBox animateDelay={1 + 0.1 * i} key={href}>
                <a className={className} href={href}>
                  {name}
                </a>
              </AnimateBox>
            )
          })}
        </div>
      </div>

      <div className='list-box'>
        <ul>
          {listData.map((item, index) => {
            const { id, title, descriptions, thumbnail } = item
            const url = `/industry/${id}`
            return (
              <AnimateBox animateDelay={(index % 3) * 0.2} className='item' key={id}>
                <div className='img'>
                  <div className='pic' style={{ backgroundImage: `url(${thumbnail})` }} />
                </div>
                <div className='txt'>
                  <h2>
                    <a href={url}>{title}</a>
                  </h2>
                  <p>{descriptions}</p>
                  <a className='look-more-blue' href={url}>
                    了解详情
                  </a>
                </div>
              </AnimateBox>
            )
          })}
        </ul>
      </div>
    </Wrap>
  )
}
